// @flow
import OrgsDishesPage, { dataKey } from './OrgsDishesPage';

export default OrgsDishesPage;
export { dataKey };
